var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

import React from 'react';
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ['styles']);

  return React.createElement('svg', _extends({
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    width: '116.2',
    height: '28',
    viewBox: '0 0 116.2 28'
  }, props), React.createElement('defs', null, React.createElement('linearGradient', {
    id: 'a',
    x1: '18.4',
    y1: '4.53',
    x2: '18.4',
    y2: '41.39',
    gradientUnits: 'userSpaceOnUse'
  }, React.createElement('stop', { offset: '0', stopColor: '#EC257A' }), React.createElement('stop', { offset: '1', stopColor: '#9E1F63' })), React.createElement('linearGradient', {
    id: 'b',
    x1: '19.51',
    y1: '4.54',
    x2: '19.51',
    y2: '41.38',
    xlinkHref: '#a'
  }), React.createElement('linearGradient', {
    id: 'c',
    x1: '8.46',
    y1: '1.06',
    x2: '8.46',
    y2: '29.04',
    gradientUnits: 'userSpaceOnUse'
  }, React.createElement('stop', { offset: '0', stopColor: '#86C443' }), React.createElement('stop', { offset: '1', stopColor: '#038743' }))), React.createElement('title', null, 'CXA Group'), React.createElement('path', {
    d: 'M32.2 8.6a5.4 5.4 0 0 1 4.6 2.1l-1.7 1.6a3.2 3.2 0 0 0-2.8-1.4c-2.2 0-3.6 1.6-3.6 4s1.4 4 3.6 4a3.2 3.2 0 0 0 2.8-1.4l1.7 1.6a5.4 5.4 0 0 1-4.6 2.1 6 6 0 0 1-6.2-6.3 6 6 0 0 1 6.2-6.3zm11.3 7.8l-3.1 4.5h-2.9l4.4-6.1-4.1-5.9h2.9l2.8 4.1 2.8-4.1h2.9l-4.1 5.8 4.4 6.2h-2.9zm15.1 3.1a5 5 0 0 1-3.9 1.6 4 4 0 0 1-4.2-4c0-2.7 2.2-3.9 4.2-3.9a4.9 4.9 0 0 1 3.9 1.7v-1.8c0-1.4-1.1-2.2-2.8-2.2a4.9 4.9 0 0 0-3.5 1.5l-1.1-1.8a7.1 7.1 0 0 1 5-1.9c2.6 0 5 1.1 5 4.3v7.9h-2.6zm0-3.2a3.5 3.5 0 0 0-2.8-1.2 2.3 2.3 0 0 0-2.5 2.2 2.3 2.3 0 0 0 2.5 2.1 3.5 3.5 0 0 0 2.8-1.2zm6.3 6.6a4.3 4.3 0 0 0 3.7 1.6c2 0 3.8-1.1 3.8-3.7V19a4.8 4.8 0 0 1-3.9 2.1c-3 0-5-2.3-5-6s2-6 5-6a4.7 4.7 0 0 1 3.9 2.1V9.3h1.2v11.5c0 3.5-2.3 4.8-5.1 4.8a5.3 5.3 0 0 1-4.4-1.7zm7.6-10.6a4.5 4.5 0 0 0-3.7-2.1c-2.5 0-3.9 2.1-3.9 4.9s1.4 4.9 3.9 4.9a4.5 4.5 0 0 0 3.7-2.1zm3.8-2.9h1.2v2a4.8 4.8 0 0 1 3.8-2.2v1.4h-.6a4.3 4.3 0 0 0-3.2 2.1v8.2h-1.2zm5.6 5.8c0-3.4 2.1-6 5.4-6s5.4 2.7 5.4 6-2.1 6.1-5.4 6.1-5.5-2.8-5.5-6.2zm9.5 0c0-2.6-1.5-4.9-4.1-4.9s-4.2 2.2-4.2 4.8 1.5 4.9 4.1 4.9 4.2-2.3 4.2-4.9zm10.9 4.1a5.7 5.7 0 0 1-4.1 2c-2.3 0-3.5-1.1-3.5-3.7V9.3h1.2v7.8c0 2.2 1.1 2.9 2.7 2.9a4.8 4.8 0 0 0 3.7-1.9V9.3h1.2v11.6h-1.2zm3.8 6.1V9.3h1.2v1.8a4.8 4.8 0 0 1 3.9-2.1c3 0 5 2.3 5 6s-2 6.1-5 6.1a4.8 4.8 0 0 1-3.9-2.1v6.3zm4.9-15.1a4.5 4.5 0 0 0-3.7 2.1v5.5A4.6 4.6 0 0 0 111 20c2.5 0 3.9-2.1 3.9-4.9s-1.4-4.9-3.9-4.9z',
    fill: '#555759'
  }), React.createElement('path', {
    d: 'M19.8 6a2.4 2.4 0 0 0-1.4-.7c-1.2-.1-2.1 1.1-1.9 2.6v.3a4.6 4.6 0 0 1-.3 2.3l-.2.4v.3c-.2.7.1 1 .7.8l.5-.4.2-.2a2.3 2.3 0 0 1 1.7-.6h.2c1.1 0 1.9-1.1 1.7-2.6a3.8 3.8 0 0 0-.5-1.5z',
    transform: 'translate(-.9 -1.1)',
    fill: 'url(#a)'
  }), React.createElement('path', {
    d: 'M22.7 25.6a3 3 0 0 0 .3-1.9 3.7 3.7 0 0 0-3-3.3h-.3a4 4 0 0 1-2.3-.8l-.4-.4-.3-.2c-.7-.4-1-.1-.6.7l.5.8.2.3a5.7 5.7 0 0 1 1 2.5v.3a3.6 3.6 0 0 0 2.9 3 2 2 0 0 0 1.4-.4z',
    transform: 'translate(-.9 -1.1)',
    fill: 'url(#b)'
  }), React.createElement('path', {
    d: 'M12.8 11.4h-.7a4.3 4.3 0 0 1-2.9-1.5 6.3 6.3 0 0 1-1.3-3.5 3.8 3.8 0 0 0 0-.6v-.3C7.6 3.2 6 1.2 4.2 1.1S.8 2.7.9 5.2s1.7 4.5 3.7 4.6h.8a4.2 4.2 0 0 1 3.4 1.6 5.8 5.8 0 0 1 1.1 2 6.8 6.8 0 0 1 .4 1.9 5.2 5.2 0 0 1-.7 3.1l-.3.5a3.4 3.4 0 0 1-2.8 1.2h-.9c-2 0-3.6 1.8-3.5 4.2A4.9 4.9 0 0 0 6.3 29c2.2.2 3.9-1.7 3.7-4.2v-1a5.2 5.2 0 0 1 .9-4.2 3.3 3.3 0 0 1 2.6-1.2h.3c1.5 0 2.5-1.5 2.4-3.3s-1.8-3.5-3.4-3.7z',
    transform: 'translate(-.9 -1.1)',
    fill: 'url(#c)'
  }));
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/client-logo/logo.svg.react.js
// module id = null
// module chunks = 